import { Component } from "@angular/core"
import { MatDialogRef } from "@angular/material/dialog"

@Component({
  selector: 'delete-keyword-confirmation',
  templateUrl: './delete-keyword-confirmation-dialog.component.html',
  styleUrls: ['./delete-keyword-confirmation-dialog.component.scss']
})
export class DeleteKeywordConfirmationDialogComponent {

  DELETE_TITLE_LOCALIZED: string = $localize`:Delete word translation|Translation for the word Delete@@Delete:Delete`;

  constructor(
    private _dialogRef: MatDialogRef<DeleteKeywordConfirmationDialogComponent>
  ) {}

  /** */
  confirm() {
    this._dialogRef.close(true);
  }

  /** */
  cancel() {
    this._dialogRef.close(false)
  }

}